let instance = null;

export
default class AnimationTrigger {
    constructor() {
        this.observer = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                obs.unobserve(entry.target);
                this.runAnimation(entry.target);
            });
        });
    }

    init() {
        document.querySelectorAll('.animation-trigger').forEach(element => {
            this.observe(element);
        });
    }

    runAnimation(element) {
        element.classList.add('run-animation');
    }

    observe(element) {
        this.observer.observe(element);
    }

    static getInstance() {
        if (!instance) {
            instance = new AnimationTrigger();
        }

        return instance;
    }
}
